import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  CImage,
  CFormLabel,
  CButtonGroup,
  CFormCheck,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cilBell,
  cilEnvelopeOpen,
  cilList,
  cilMenu,
  cilSun,
  cilMoon,
  cilContrast,
  cilLanguage,
  cifGb,
  cifEs,
  cifPl,
} from "@coreui/icons";
import { useTranslation } from "react-i18next";
import {
  CDropdown,
  useColorModes,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react-pro";
import { AppBreadcrumb } from "./index";
import { AppHeaderDropdown, AppHeaderDropdownNotif } from "./header/index";
import { logo } from "../assets/brand/logo";
import zyplelogo from "./images/logo.jpg";
import { Display } from "react-bootstrap-icons";
import { useState, useEffect, useRef } from "react";
const AppHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const theme = useSelector((state) => state.theme);

  theme === "dark"
    ? document.body.classList.add("dark-theme")
    : document.body.classList.remove("dark-theme");
  const headerRef = useRef();
  //const { colorMode, setColorMode } = useColorModes('coreui-pro-react-admin-template-theme-default')
  const { i18n, t } = useTranslation();

  const asideShow = useSelector((state) => state.asideShow);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      headerRef.current &&
        headerRef.current.classList.toggle(
          "shadow-sm",
          document.documentElement.scrollTop > 0
        );
    });
  }, []);
  return (
    <CHeader position="sticky" className="mb-4" ref={headerRef}>
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: "set", sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          {/* <CIcon icon={logo} height={48} alt="Logo" /> */}
          <CImage src={zyplelogo} height={48} />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <CNavLink
              to="/Reports/SmartReportExecute"
              component={NavLink}
              // onClick={(e) => {
              //   e.preventDefault();
              //   return false;
              // }}
            >
              {t("Reports")}
            </CNavLink>

            <CNavLink
              to="/dashboard"
              component={NavLink}
              style={{ display: "none" }}
            >
              Dashboard
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#" style={{ display: "none" }}>
              Users
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#" style={{ display: "none" }}>
              Settings
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        {/* <CHeaderNav className="ms-auto me-4">
          <CButtonGroup aria-label="Theme switch">
            <CFormCheck
              type="radio"
              button={{ color: "primary" }}
              name="theme-switch"
              id="btn-light-theme"
              autoComplete="off"
              label={<CIcon icon={cilSun} />}
              checked={theme === "default"}
              onChange={() => dispatch({ type: "set", theme: "light" })}
            />
            <CFormCheck
              type="radio"
              button={{ color: "primary" }}
              name="theme-switch"
              id="btn-dark-theme"
              autoComplete="off"
              label={<CIcon icon={cilMoon} />}
              checked={theme === "dark"}
              onChange={() => dispatch({ type: "set", theme: "dark" })}
            />
          </CButtonGroup>
        </CHeaderNav> */}
        <CHeaderNav className="d-md-flex ms-auto">
        <li className="nav-item py-1">
          <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
        </li>
          <AppHeaderDropdownNotif />
        </CHeaderNav>
        <CHeaderNav className="ms-3 me-4">
        <li className="nav-item py-1">
          <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
        </li>
          <CNavItem>
            <CFormLabel size="sm" style={{ marginBottom: "0" }}>
              {localStorage.getItem("user")}
            </CFormLabel>
            <br />
            <CFormLabel size="sm">{localStorage.getItem("email")}</CFormLabel>
          </CNavItem>
          {/* <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilList} size="lg" />
            </CNavLink>
          </CNavItem> */}
          {/* <CNavItem><CNavLink href="#">
              <CIcon icon={cilEnvelopeOpen} size="lg" />
            </CNavLink> </CNavItem>*/}
        </CHeaderNav>
        <CHeaderNav className="ms-auto ms-md-0">
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          {/* <CDropdown variant="nav-item" placement="bottom-end">
            <CDropdownToggle caret={false}>
              <CIcon icon={cilLanguage} size="lg" />
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                active={i18n.language === 'en'}
                className="d-flex align-items-center"
                as="button"
                onClick={() => i18n.changeLanguage('en')}
              >
                <CIcon className="me-2" icon={cifGb} size="lg" /> English
              </CDropdownItem>
              <CDropdownItem
                active={i18n.language === 'es'}
                className="d-flex align-items-center"
                as="button"
                onClick={() => i18n.changeLanguage('es')}
              >
                <CIcon className="me-2" icon={cifEs} size="lg" /> Español
              </CDropdownItem>
              <CDropdownItem
                active={i18n.language === 'pl'}
                className="d-flex align-items-center"
                as="button"
                onClick={() => i18n.changeLanguage('pl')}
              >
                <CIcon className="me-2" icon={cifPl} size="lg" /> Polski
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown> */}
          <CDropdown variant="nav-item" placement="bottom-end">
            <CDropdownToggle caret={false}>
              {theme === "dark" ? (
                <CIcon icon={cilMoon} size="lg" />
              ) : (
                // : theme === 'auto' ? (
                //   <CIcon icon={cilContrast} size="lg" />
                // )
                <CIcon icon={cilSun} size="lg" />
              )}
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                active={theme === "light"}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => dispatch({ type: "set", theme: "light" })}
              >
                <CIcon className="me-2" icon={cilSun} size="lg" /> {t("light")}
              </CDropdownItem>
              <CDropdownItem
                active={theme === "dark"}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => dispatch({ type: "set", theme: "dark" })}
              >
                <CIcon className="me-2" icon={cilMoon} size="lg" /> {t("dark")}
              </CDropdownItem>
              {/* <CDropdownItem
                active={colorMode === 'auto'}
                className="d-flex align-items-center"
                as="button"
                type="button"
                onClick={() => setColorMode('auto')}
              >
                <CIcon className="me-2" icon={cilContrast} size="lg" /> Auto
              </CDropdownItem> */}
            </CDropdownMenu>
          </CDropdown>
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <AppHeaderDropdown />
        </CHeaderNav>
        {/* <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav> */}
      </CContainer>
      {/* <CHeaderDivider /> 
       <CContainer xxl >
        <AppBreadcrumb />
      </CContainer>*/}
    </CHeader>
  );
};

export default AppHeader;
